import { render, staticRenderFns } from "./PaxelboxLanding.vue?vue&type=template&id=4c14225e&scoped=true&"
import script from "./PaxelboxLanding.vue?vue&type=script&lang=js&"
export * from "./PaxelboxLanding.vue?vue&type=script&lang=js&"
import style0 from "./PaxelboxLanding.vue?vue&type=style&index=0&id=4c14225e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c14225e",
  null
  
)

export default component.exports